var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.931,
    height: 14.55,
    viewBox: "0 0 19.931 14.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cvv",
    transform: "translate(0.1 -63.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12580",
    "data-name": "Group 12580",
    transform: "translate(0 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33800",
    "data-name": "Path 33800",
    d: "M18.109,64H1.622A1.623,1.623,0,0,0,0,65.622V76.728A1.623,1.623,0,0,0,1.622,78.35H18.109a1.623,1.623,0,0,0,1.622-1.622V65.622A1.623,1.623,0,0,0,18.109,64Zm-16.488.9H18.109a.725.725,0,0,1,.725.725v1.069H.9V65.622a.725.725,0,0,1,.725-.725ZM18.109,77.453H1.622A.725.725,0,0,1,.9,76.728V67.587H18.834v9.141A.725.725,0,0,1,18.109,77.453Z",
    transform: "translate(0 -64)",
    fill: "#bcbcbc",
    stroke: "#bcbcbc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33801",
    "data-name": "Path 33801",
    d: "M87.676,214.27h.937a.468.468,0,0,0,0-.937h-.937a2.342,2.342,0,1,0,0,4.684h.937a.468.468,0,1,0,0-.937h-.937a1.405,1.405,0,1,1,0-2.81Z",
    transform: "translate(-81.782 -207.182)",
    fill: "#bcbcbc",
    stroke: "#bcbcbc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33802",
    "data-name": "Path 33802",
    d: "M302.108,213.36a.468.468,0,0,0-.6.273l-.967,2.578-.967-2.578a.468.468,0,0,0-.877.33l1.405,3.747a.468.468,0,0,0,.877,0l1.405-3.747A.468.468,0,0,0,302.108,213.36Z",
    transform: "translate(-286.233 -207.179)",
    fill: "#bcbcbc",
    stroke: "#bcbcbc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33803",
    "data-name": "Path 33803",
    d: "M195.441,213.36a.468.468,0,0,0-.6.273l-.967,2.578-.967-2.578a.468.468,0,0,0-.877.33l1.405,3.747a.468.468,0,0,0,.877,0l1.405-3.747A.468.468,0,0,0,195.441,213.36Z",
    transform: "translate(-184.006 -207.179)",
    fill: "#bcbcbc",
    stroke: "#bcbcbc",
    strokeWidth: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvv);
export default __webpack_public_path__ + "static/media/cvv.94c7930688a8c505e2c947a633c16b84.svg";
export { ForwardRef as ReactComponent };